module.exports = __webpack_public_path__ + "img/detail-extend.1c205892.png";